import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFilters, fetchGeneralFilters } from "./filters.service";
import {
  FilterRequest,
  FiltersResponse,
  GeneralFiltersRequest,
  GeneralFiltersResponse,
} from "./filters.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getFilters = createAsyncThunk<
  FiltersResponse,
  FilterRequest,
  { rejectValue: string }
>("filters/getFilters", async (data, { rejectWithValue }) => {
  try {
    return await fetchFilters(data);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getGeneralFilters = createAsyncThunk<
  GeneralFiltersResponse,
  GeneralFiltersRequest,
  { rejectValue: string }
>("filters/getGeneralFilters", async (data, { rejectWithValue }) => {
  try {
    return await fetchGeneralFilters(data);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
